import React, { useContext, useEffect, useState } from 'react';
import { ServiceResponse } from '../../../app/services/shared/interfaces';
import { AppContext } from '../../../contexts/AppContext';
import { toast } from 'react-toastify';
import useReactConfirmAlert from '../../../hooks/useReactConfirmAlert';
import LazyLoading from '../../../components/LazyLoading';
import ButtonCancelForm from '../../../components/buttons/ButtonCancelForm';
import ButtonSaveForm from '../../../components/buttons/ButtonSaveForm';
import { CauseNoteDataForm, NoteClassifications, NoteTypes } from '../../../app/models/CauseNote';
import useCauseNoteService from '../../../app/services/hooks/useCauseNoteService';
import CauseNoteForm from './forms/CauseNoteForm';



interface Props {
    onSaved?: () => void;
    onCancel?: () => void;
    onError?: () => void;
}

const CauseNoteCreate = ({ onSaved, onCancel, onError }: Props) => {
    const { showLoading, hideLoading, changeAnimation } = useContext(AppContext);

    const [errorGetData, setErrorGetData] = useState('');
    const [causeNote, setcauseNote] = useState<CauseNoteDataForm>({ name: '', description:''});
    const [noteTypes, setNoteTypes] = useState<NoteTypes[]>([]);
    const [noteClassifications, setNoteClassifications] = useState<NoteClassifications[]>([]);
    const [errorFields, setErrorFields] = useState<any>();

    const { createCauseNote, fetchingCreateCauseNote ,fetchingStoreCauseNote, storeCauseNote } = useCauseNoteService();


    useEffect(() => {
        create();
    }, []);

    const create = () => {
        if (showLoading) showLoading('loading', 'Cargando datos...');
        createCauseNote({
            onSuccess: (response: ServiceResponse) => {
                setNoteTypes(response.data.note_types || []);
                setNoteClassifications(response.data.classifications|| []);
                if (hideLoading) hideLoading();
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
                toast.error(response.message);
                if (onError) onError();
            }
        });
    };

 
    const store = () => {
        if (showLoading) showLoading('loading', 'Guardando motivo notas...');
        storeCauseNote(causeNote, {
            onSuccess: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
                toast.success(response.message, { autoClose: 2500 });
                if (onSaved) onSaved();
            },
            onError: (response: ServiceResponse) => {
                toast.error(response.message);
            },
            onFieldError: (errorFields: ServiceResponse) => {
                if (hideLoading) hideLoading();
                
                // Verificar si hay errores no asociados a campos específicos (non_field_errors)
                if (errorFields.data && errorFields.data.non_field_errors && errorFields.data.non_field_errors.length > 0) {
                    const errorMessage = errorFields.data.non_field_errors[0];
                    useReactConfirmAlert().errorAlert({
                        title: 'Error de validación',
                        message: errorMessage
                    });
                } else {
                    // Si no hay non_field_errors, establecer los errores de campos normalmente
                    setErrorFields(errorFields.data);
                }
            }
        });
    };

    const cancel = () => {
        if (onCancel) onCancel();
    };

    if (errorGetData !== '') {
        return <div>{errorGetData}</div>;
    }

    return (
        <>
            <div className="row">
                <div className="col-12">
                    <CauseNoteForm
                        causeNoteDataForm={causeNote}
                        setCauseNoteDataForm={setcauseNote}
                        noteTypes={noteTypes}
                        setNoteTypes={(newNoteType) => setNoteTypes([newNoteType])}
                        noteClassifications={noteClassifications}
                        setNoteClassifications={(newNoteClassification) => setNoteClassifications([newNoteClassification])}
                        errorFields={errorFields}
                    />
                </div>
            </div>
            <hr />
            <div className="row justify-content-end">
                <div className="col-auto">
                    <ButtonCancelForm callbackCancel={cancel} locked={fetchingStoreCauseNote} />
                </div>
                <div className="col-auto">
                    <ButtonSaveForm callbackSave={store} locked={fetchingStoreCauseNote} />
                </div>
            </div>
        </>
    );
};

export default CauseNoteCreate;
